<!-- @format -->

<div class="form-group-mimic">
  <div role="heading" class="sis-label" [attr.aria-level]="level">{{
    "SIS_COMPONENTS.COURSE_UNIT_REALISATION_INFO.SEATS" | translate
  }}</div>
  @if (maxSelected) {
    <p class="form-control-static">
      {{ maxSelected }}
    </p>
  }
  @if (!maxSelected) {
    <p class="form-control-static">
      {{ "COMMON.NOT_DEFINED" | translate }}
    </p>
  }
  @if (selectedUsersQuotas.length > 0 && maxSelected) {
    @for (quota of selectedUsersQuotas; track quota) {
      <div>
        <p>{{ quota.name | localizedString }}</p>
        <ul>
          <li>
            <p class="form-control-static">
              <transloco [content]="'SIS_COMPONENTS.COURSE_UNIT_REALISATION_INFO.SEATS_MINIMUM' | translate: { seats: quota.size }" /> </p
          ></li>
        </ul>
      </div>
    }
  }
  @if (maximumUsersQuotas.length > 0 && maxSelected) {
    @for (quota of maximumUsersQuotas; track quota) {
      <div>
        <p>{{ quota.name | localizedString }}</p>
        <ul>
          <li>
            <p class="form-control-static">
              <transloco [content]="'SIS_COMPONENTS.COURSE_UNIT_REALISATION_INFO.SEATS_MAXIMUM' | translate: { seats: quota.size }" /> </p
          ></li>
        </ul>
      </div>
    }
  }
</div>
